module.exports = __webpack_public_path__ + "img/mainBtnBg.e02f27a5.png";